import { ProductionData } from "../../types/responseTypes";
import mockHourlyData from "./mockHourlyProductionData";

async function getHourlyProductionData(): Promise<ProductionData[] | null> {
  try {

    const url = `https://ruuf-backend.online/huawei/hourly-data`;
   
    const timeout = new Promise<Response>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 10000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    if (response.status === 200 || response.status === 201) {
      console.log("Daily Production Data fetched successfully");
      const productionData: ProductionData[] = await response.json();
      return productionData;
    } else if (response.status === 502) {
      console.error("Invalid cookie: Error fetching Hourly Production Data");
      return null;
    } else {
      console.error("response status: ", response.status);
      console.log("response: ", response);
      throw new Error("Could not fetch Hourly Production Data");
    }
  } catch (error) {
    console.error("Error fetching Hourly Production Data (returning mockHourlyData).", error);
    return mockHourlyData;
  }
}

export default getHourlyProductionData;
